var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('v-overlay',{attrs:{"value":_vm.loading}},[_c('v-progress-circular',{attrs:{"size":70,"indeterminate":"","color":"grey lighten-5"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }